/**
 * Describes what a table lists, so the table itself can phrase its own empty,
 * filtered and error states with correct French agreement.
 *
 * `singular` is the bare noun phrase used after "Aucun(e)" — no article, no
 * trailing adjective ("facture", "commande billetterie", "lieu de travail").
 */
export interface TableEntity {
  singular: string;
  /** Defaults to `singular + 's'`; set it for irregulars ("journaux", "lieux de travail"). */
  plural?: string;
  feminine?: boolean;
}

function pluralize(entity: TableEntity) {
  return entity.plural ?? `${entity.singular}s`;
}

export function noResultsMessage(entity: TableEntity, isFiltered?: boolean) {
  const aucun = entity.feminine ? 'Aucune' : 'Aucun';
  return isFiltered
    ? `${aucun} ${entity.singular} ne correspond aux filtres`
    : `${aucun} ${entity.singular}`;
}

export function loadErrorMessage(entity: TableEntity) {
  return `Impossible de charger les ${pluralize(entity)}`;
}
